export type Theme = "light" | "dark" | "system";

export const THEME_STORAGE_KEY = "memoru-theme";
export const DARK_MEDIA_QUERY = "(prefers-color-scheme: dark)";

function isTheme(value: string | null): value is Theme {
  return value === "light" || value === "dark" || value === "system";
}

export function readThemePreference(): Theme {
  try {
    const storedTheme = window.localStorage.getItem(THEME_STORAGE_KEY);
    return isTheme(storedTheme) ? storedTheme : "system";
  } catch {
    return "system";
  }
}

export function applyTheme(theme: Theme) {
  const root = window.document.documentElement;
  const resolvedTheme = theme === "system"
    ? window.matchMedia?.(DARK_MEDIA_QUERY).matches ? "dark" : "light"
    : theme;

  root.classList.remove("light", "dark");
  root.classList.add(resolvedTheme);
  root.dataset.theme = theme;
  root.style.colorScheme = resolvedTheme;
}

export function initializeTheme() {
  applyTheme(readThemePreference());
}

